import type { Options } from '@contentful/rich-text-react-renderer';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { useStyles } from './RichText.styles';
import { createRenderNodeMap } from './renderers';
import type { RichTextProps } from './types';
import { renderTextWithLineBreaks } from './utils';

export default function RichText({
  content,
  className,
  textId,
  title,
  variants,
  blockProps,
  blockClasses,
}: RichTextProps) {
  const { classes, cx } = useStyles();
  const generatedId = title
    ? `rc-${title.toLowerCase().replace(/\s+/g, '-')}`
    : undefined;

  const renderOptions: Options = {
    renderText: renderTextWithLineBreaks,
    renderNode: createRenderNodeMap({
      classes,
      cx,
      variants,
      blockProps,
      blockClasses,
    }),
  };

  return (
    <div id={textId ?? generatedId} className={className}>
      {documentToReactComponents(content, renderOptions)}
    </div>
  );
}
